module.exports = __webpack_public_path__ + "static/media/shower-rain-day.2bd23641.svg";